import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import {
  TextInput, IntInput
} from "components/Input/Index.js";
import CustomSelect from "components/Input/CustomSelect.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { sessiontext } from "variables/MBM/session";
import { postSession, putSession, getMBMAVOBBoxs } from "services/ConfigServices";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { sessiontypeData } from "variables/MBM/lists/session";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  submitButtonEdit: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "5ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabledEdit: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "5ch",
    width: "60ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

function SessionDialog(props) {
  const { closeModal, refetch, currentSession } = props;
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = advancedSearchContext;

  const [handlerid, setHandlerid] = useState(currentSession?.handlerid || "");
  const [sessiontype, setSessiontype] = useState(currentSession?.sessiontype || "");
  const [sessionurl, setSessionurl] = useState(currentSession?.sessionurl || "");
  const [watchperiod, setWatchperiod] = useState(currentSession?.watchperiod || 15);
  const [name, setName] = useState(currentSession?.name || "");
  const [groups, setGroups] = useState(currentSession?.groupid ? "" + currentSession.groupid : "");

  const [avobboxids, setAvobboxids] = useState([]);

  const [buttonDisabled, setButtonDisabled] = useState(true);


  useEffect(() => {
    console.log(groups);
    if (
      name.length > 0 &&
      handlerid &&
      sessiontype > 0 &&
      (sessiontype === 5 || sessiontype === 3 || sessionurl.length > 0) &&
      (groups.length > 0 && groups!=="0") &&
      watchperiod
    ) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [name, groups, handlerid, sessiontype, sessionurl, watchperiod]);

  useEffect(() => {
    if (chartIdGroup > 0) {
      axios
        .get(
          getMBMAVOBBoxs(chartIdGroup, "avobenergybox"),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          let tmpavobboxidsData = res.data.avobboxs?.map((data) => {
            return (
              {
                name: data.name + '(' + data.uniqueid + ')' , id: data.id
              }
            );

          });
          setAvobboxids(tmpavobboxidsData || []);
        });
    }
  }, [chartIdGroup]);

  const handleSubmit = async (event) => {
    if (currentSession)
      updateSession(event);
    else
      createSession(event);
  };

  const handleNameChange = (event) => { setName(event.target.value); };
  const handleHandleridChange = (event) => { setHandlerid(event.target.value); };
  const handleSessiontypeChange = (event) => { setSessiontype(event.target.value); };
  const handleSessionurlChange = (event) => { setSessionurl(event.target.value); };
  const handleWatchperiodChange = (event) => { setWatchperiod(event.target.value); };

  const createSession = async (event) => {
    await axios
      .post(
        postSession(),
        {
          groups,
          name,
          sessiontype,
          watchperiod,
          sessionurl,
          handlerid
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        console.log(res);
        if (res.status == 200) {
          setNotification("success", "Session créée");
        } else setNotification("error", res.data.message);
        closeModal();
        refetch();
      })
      .catch((error) => {
        console.log(error.response);
        setNotification("error", "Une erreur est survenue : " + error.response?.data?.message);
      });
  };

  const updateSession = async (event) => {

    await axios
      .put(
        putSession(currentSession.id),
        {
          groups,
          name,
          watchperiod,
          sessionurl,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Session modifiée");
        } else setNotification("error", "Une erreur est survenue");
        closeModal();
        refetch();
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const classes = useStyles();

  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={6} md={7} lg={7}>
            <div>
              <CustomSelect
                inputTitle={sessiontext.handlerid}
                selectValue={handlerid}
                handleSelectValueChange={handleHandleridChange}
                data={avobboxids}
                disabled={currentSession}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={sessiontext.type}
                selectValue={sessiontype}
                handleSelectValueChange={handleSessiontypeChange}
                data={sessiontypeData}
                disabled={currentSession}
              />
            </div>
            < div >
              <TextInput
                isRequired
                inputTitle={sessiontext.name}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>

            {(sessiontype && sessiontype !== 5) && (
              <>
                <div>
                  <TextInput
                    isRequired
                    inputTitle={sessiontext.sessionurl}
                    textInput={sessionurl}
                    handleTextInputChange={handleSessionurlChange}
                  />
                </div>

              </>
            )}
            {(sessiontype && sessiontype !== 5) && (
              <>
                <div>
                  <IntInput
                    isRequired
                    inputTitle={sessiontext.watchperiod}
                    intInput={watchperiod}
                    handleIntInputChange={handleWatchperiodChange}
                  />
                </div>
              </>
            )}
          </GridItem>

          <GridItem xs={12} sm={6} md={5} lg={5}>
            <div className={classes.treeVisible}>
              <TreeLabel>Choix du périmètre</TreeLabel>
              <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                <EmbeddedEntitesTree
                  selectedIds={setGroups}
                  userSelectedIds={groups}
                  filterfromnode={chartIdGroup[0]}
                />
              </ImageList>
            </div>
          </GridItem>

        </GridContainer>
        <Button
          disabled={buttonDisabled}
          className={
            currentSession ?
              buttonDisabled
                ? classes.submitButtonDisabledEdit
                : classes.submitButtonEdit
              :
              buttonDisabled
                ? classes.submitButtonDisabled
                : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </form>
    </>
  );
}

export default SessionDialog;
